import { sagaCreator } from '@adrias-online/steiner';

import { createSagas } from '../../../helpers/portaleModuleHelper';
import { actions, actionTypes } from '../actions/portaliConsigliati';
import { selectors, DEFAULT_STATE } from '../reducers/portaliConsigliati';
import api from '../apis/portaliConsigliati';

const sagas = createSagas(
    'portaliConsigliati',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Consigliati (Primo Piano)',
        clientFilters: true
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
